import React from "react";

const Privacy: React.FC = () => (
  <div className="min-h-screen px-6 py-12">
    <div className="max-w-3xl mx-auto bg-white rounded-lg p-10 border border-border font-body text-ink">
      <h1 className="text-4xl font-bold font-display mb-6">Privacy Policy</h1>
      <p className="text-gray-500 mb-8">Last updated: 5 October 2026</p>

      <h2 className="text-2xl font-semibold mb-2">1. Who we are</h2>
      <p className="mb-6">
        Exam Revision ("we", "us") operates this site. Contact us about privacy matters at{" "}
        <a href="mailto:support@examsrevision.com" className="text-primary underline">support@examsrevision.com</a>.
      </p>

      <h2 className="text-2xl font-semibold mb-2">2. What we collect</h2>
      <ul className="list-disc pl-6 mb-6 space-y-1">
        <li>Account data: email address, password (stored as a salted hash, never in plain text), and country.</li>
        <li>Payment data: processed directly by Stripe. We receive and store the payment status and Stripe's payment identifier, not your card details.</li>
        <li>Usage data: your quiz/exam attempts and scores, used to track your learning progress.</li>
      </ul>

      <h2 className="text-2xl font-semibold mb-2">3. Why we collect it</h2>
      <ul className="list-disc pl-6 mb-6 space-y-1">
        <li>To create and secure your account, and let you log in.</li>
        <li>To process your subscription payment and know whether your account should be active.</li>
        <li>To send you account-related emails (welcome, password reset, renewal reminders).</li>
        <li>To track your progress and personalise the questions you're shown.</li>
      </ul>

      <h2 className="text-2xl font-semibold mb-2">4. Retention</h2>
      <p className="mb-6">
        We keep account and progress data for as long as your account is active. If you close your account or ask us to
        delete it, we delete it, except for anything we're legally required to keep (such as payment records for tax
        purposes). You can request deletion at any time (see Section 6).
      </p>

      <h2 className="text-2xl font-semibold mb-2">5. Third parties</h2>
      <ul className="list-disc pl-6 mb-6 space-y-1">
        <li><strong>Stripe</strong> — processes subscription payments. Your email and the subscription amount are shared with Stripe to process and verify payment; see Stripe's own privacy policy.</li>
        <li><strong>Amazon Web Services (SES)</strong> — sends transactional emails (welcome, password reset, renewal reminders) to your registered email address.</li>
      </ul>
      <p className="mb-6">We do not sell your personal data.</p>

      <h2 className="text-2xl font-semibold mb-2">6. Your rights</h2>
      <p className="mb-6">
        You can ask us to access, correct, or delete your personal data by emailing{" "}
        <a href="mailto:support@examsrevision.com" className="text-primary underline">support@examsrevision.com</a>.
      </p>

      <h2 className="text-2xl font-semibold mb-2">7. Cookies</h2>
      <p>
        We use essential browser storage (such as your login session) required for the site to function. We do not currently
        use analytics or advertising cookies. If that changes, this policy and the site will be updated accordingly.
      </p>
    </div>
  </div>
);

export default Privacy;
